module.exports = __webpack_public_path__ + "img/Redis.107069d8.png";